import { render, staticRenderFns } from "./MemQuota.vue?vue&type=template&id=2030b1aa&"
import script from "./MemQuota.vue?vue&type=script&lang=js&"
export * from "./MemQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports